// extracted by mini-css-extract-plugin
export default {"columnLink":"CommunityBanner-module--columnLink--390ae","columnTitle":"CommunityBanner-module--columnTitle--d5d87"};